import Nav from 'react-bootstrap/Nav';

import { useStyles } from '../theme';
import { TabItem } from './TabItem';

const styles = (theme) => ({
  nav: {
    marginBottom: 39,
    gap: 0,
    '-webkit-box-shadow': 'inset 0 -1px 0 0 #D2D2D2',
    '-moz-box-shadow': 'inset 0 -1px 0 0 #D2D2D2',
    boxShadow: 'inset 0 -1px 0 0 #D2D2D2'
  }
});

export const TabGroup = ({ tabs, setAppliedTab }) => {
  const classes = useStyles(styles);

  const handleSelectValueChange = (value) => {
    setAppliedTab(value);
  };

  return (
    <Nav
      variant="underline"
      defaultActiveKey="all"
      className={classes.nav}
      onSelect={handleSelectValueChange}
    >
      {tabs.map((tab) => (
        <TabItem tab={tab} key={tab.id} />
      ))}
    </Nav>
  );
};
